import React from 'react';
import {Link as RouterLink, useHistory} from 'react-router-dom';
import Link from '@mui/material/Link';
import {Container, Grid, Button} from '@mui/material'
import {ConsigneeService} from '../../../services';
import CustomDataGrid from '../../../customUtil/DataGrid';

const columns = [
    {
        field: 'consigneeName', headerName: 'Name', width: 400,
        renderCell: (params) =>
            (<Link style={{textDecoration: 'none'}} component={RouterLink} to={'/references/consignee/' + params.row.id}>
                {params.value}
            </Link>)
    },
    {field: 'countryName', headerName: 'Country Name', width: 200 },
    {field: 'countryCode', headerName: 'Country Code', width: 150},  
    {field: 'oneNetCode', headerName: 'One Net Code', width: 150},
    {field: 'address', headerName: 'Address', width: 250}
]

const Consignees = () => {
        const [list, setList] = React.useState([]);
        const history = useHistory();

        React.useEffect(() => {
            ConsigneeService.getAll()           
                .then((response) =>    {
                    for(let temp of response.data){
                        temp['countryCode'] = temp.country.countryCode;
                        temp['countryName'] = temp.country.countryName;
                    }
                    setList(response.data);
                }
                );
        }, []);


        return (
            <React.Fragment>
                <Container>
                    <header>
                        <h1>Consignees</h1>
                    </header>
                    <Grid container spacing={5}>
                    <Grid item xs={12}>
                        <Button variant='contained' color='primary' onClick={() => {history.push('/references/consignee/new')}}>Create New</Button>
                        </Grid>    
                    
                        <Grid item xs={12}>
                        <CustomDataGrid 
                                rows={list}
                                columns={columns}
                                rowHeight={35}
                               />
                    
                        </Grid>
                    </Grid>
                </Container>
            </React.Fragment>
        );
    }
;

export default Consignees;
